<template>
  <div class="row">
    <div class="col-lg-4">
      <div class="card card-custom gutter-b" style="height: 90%">
        <div class="card-header">
            <div class="card-title">
              <h3 class="card-label">Progres Pengisian Penkin</h3>
            </div>
          </div>
        <div class="card-body">
            <div id="chart">
                <!-- <apexchart  height="440" :options="optionsTotal" :series="total"></apexchart> -->
                <apexchart type="donut" height="250" :options="chartOptions28" :series="series28">
                </apexchart>
              </div>
          
          <!-- End rounded tabs -->
        </div>
      </div>
    </div>
    <div class="col-lg-8">
        <div class="card card-custom card-stretch gutter-b">
          <!--begin::Header-->
          <div class="card-header">
            <div class="card-title">
              <h3 class="card-label">Kegiatan</h3>
            </div>
          </div>
          <!--end::Header-->
          <!--begin::Body-->
          <div class="card-body pt-0">
            <!--begin::Item-->
            <div class="mb-6" v-for="kegiatan in kegiatan" :key="kegiatan.id">
              <!--begin::Content-->
              <div class="d-flex align-items-center flex-grow-1">
                <!--begin::Checkbox-->
                <!-- <label class="checkbox checkbox-lg checkbox-lg flex-shrink-0 mr-4">
                                <input type="checkbox" value="1" />
                                <span></span>
                            </label> -->
                <!--end::Checkbox-->
                <!--begin::Section-->
                <div class="d-flex flex-wrap align-items-center justify-content-between w-100">
                  <!--begin::Info-->
                  <div class="d-flex flex-column align-items-cente py-2 w-75">
                    <!--begin::Title-->
                    <span class="text-muted font-weight-bold">{{ kegiatan.tanggal_mulai | dateToString }} s.d.
                      {{ kegiatan.tanggal_selesai | dateToString }}
                    </span>
                    <!--end::Title-->
                    <!--begin::Data-->
                    <a href="#" class="text-dark-75 font-weight-bold text-hover-primary font-size-lg mb-1">{{
                      kegiatan.agenda }}</a>
                    <!--end::Data-->
                  </div>
                  <!--end::Info-->
                  <!--begin::Label-->
                  <div v-if="kegiatan.status_sistem === 'Buka'">
                    <span class="label label-lg label-light-success label-inline font-weight-bold py-4">{{
                      kegiatan.status_sistem }}</span>
                  </div>
                  <div v-else-if="kegiatan.status_sistem === 'Tutup Sementara'">
                    <span class="label label-lg label-light-warning label-inline font-weight-bold py-4">{{
                      kegiatan.status_sistem }}</span>
                  </div>
                  <div v-else>
                    <span class="label label-lg label-light-danger label-inline font-weight-bold py-4">{{
                      kegiatan.status_sistem }}</span>
                  </div>
                  <!--end::Label-->
                </div>
                <!--end::Section-->
              </div>
              <!--end::Content-->
            </div>
            <!--end::Item-->
          </div>
          <!--end: Card Body-->
        </div>
      </div>
  </div>
</template>
<script>
import VueApexCharts from "vue-apexcharts";
export default {
  name: "DashboardOP",
  components: {
    VueApexCharts,
  },
  props: {
    chartOptions28: {
      type: Object,
      default: () => ({})
    },
    series28: {
      type: Array,
      default: () => ([])
    },
    kegiatan: {
      type: Array,
      default: () => ([])
    }
  }
}
</script>